import React from "react";
import { GenderTabsProps } from "../dashboard.types";

const GenderTabs: React.FC<GenderTabsProps> = ({
  activeTab,
  maleCount,
  femaleCount,
  onChange,
}) => {
  const tabs = [
    {
      key: "male" as const,
      label: "Male",
      count: maleCount,
    },
    {
      key: "female" as const,
      label: "Female",
      count: femaleCount,
    },
  ];

  return (
    <div className="inline-flex rounded-full bg-slate-100/90 p-1 shadow-sm">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key;

        const activeClass =
          tab.key === "male"
            ? "bg-blue-600 text-white shadow-sm"
            : "bg-pink-600 text-white shadow-sm";

        const inactiveClass =
          tab.key === "male"
            ? "text-blue-700 hover:bg-blue-50"
            : "text-pink-700 hover:bg-pink-50";

        return (
          <button
            key={tab.key}
            type="button"
            onClick={() => onChange(tab.key)}
            className={`rounded-full px-3 py-1.5 text-xs font-semibold transition ${
              isActive ? activeClass : inactiveClass
            }`}
          >
            {tab.label} ({tab.count})
          </button>
        );
      })}
    </div>
  );
};

export default GenderTabs;